import type { ClientPaths } from "newui/utils/navigation/ClientPaths";
import type { RfxListItemResource } from "../../types/rfx-list.type";

/**
 * Approvals row target.
 *
 * Actioned rows (Past tab) go to the RFx detail's `/all` read view, per
 * 006's `RfxPreApprovalActionMail` retarget.
 *
 * Pending rows (Current tab) instead need `.../view` — the Account.js route
 * (`<ViewRFQPage path="view" />`) that actually mounts `ApprovalActionButton`.
 * `/all` has no approve/reject affordance, so a pending approver landing
 * there had no clickable path to action the approval (TASK-029 item 3).
 */
export const getApprovalRowTarget = (
	clientPaths: Pick<ClientPaths, "viewApprovalRfx" | "viewRfxDetails">,
	row: Pick<RfxListItemResource, "rfx_id" | "name">,
	isPending = false
): string =>
	isPending
		? clientPaths.viewRfxDetails(row.rfx_id)
		: clientPaths.viewApprovalRfx(row.rfx_id, row.name);
